<template>
    <div>
        <div id="userList">
            <div class="searchContent" id="search">
                 <div class="p_select search_day_list" >
                     <div class="search_label">查询日期</div>
                     <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                         <el-date-picker
                                 v-model="queryStartDay"
                                 type="date"
                                 value-format="yyyy-MM-dd"
                                 :picker-options="pickerDayOptions"
                                 prefix-icon="''"
                                 class="datepicker"
                                 placeholder="选择开始日期">
                         </el-date-picker>
                         <i class="el-icon-date" ref="iconDateStart"></i>
                     </div>
                 </div>
                 <div class="p_select search_day_list" >
                     <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
                         <el-date-picker
                                 v-model="queryEndDay"
                                 type="date"
                                 value-format="yyyy-MM-dd"
                                 :picker-options="pickerDayOptions"
                                 prefix-icon="''"
                                 class="datepicker"
                                 placeholder="选择结束日期">
                         </el-date-picker>
                         <i class="el-icon-date" ref="iconDateEnd"></i>
                     </div>
                 </div>

                <div class="p_select">
                    <a  class="search_btn" @click="getImageVerifyList">查询</a>
                </div>
            </div>
            <div class="table">
                <el-table :data="imageVerifyList"  :height=winHeight :header-cell-style="tableHeaderColor">
                    <el-table-column prop="carId" label="车辆编号"></el-table-column>
                    <el-table-column prop="mile" label="里程(km)" sortable></el-table-column>
                    <el-table-column prop="carNumber" label="车牌号"></el-table-column>

                    <el-table-column label="档案状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.workStatus == 1000" style="color: #67C23A">完成</span>
                            <span v-else style="color: #E6A23C"> 未完成 </span>
                        </template>
                    </el-table-column>

                    <el-table-column label="审核用户">
                        <template slot-scope="scope">
                            <span v-if="scope.row.verifyUserId !== 0" style="color: #409EFF">{{scope.row.verifyUserName}}</span>
                            <span v-if="scope.row.verifyUserId == 0" style="color: #E6A23C"> - </span>
                        </template>
                    </el-table-column>

                    <el-table-column label="审核时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.verifyUserId !== 0" style="color: #409EFF">{{scope.row.verifyTimeLabel}}</span>
                            <span v-if="scope.row.verifyUserId == 0" style="color: #E6A23C"> - </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.verifyUserId == 0" class="update_btn" size="small" @click="examine(scope.row)">审核</el-button>
                            <span v-if="scope.row.verifyUserId !== 0" style="color: #E6A23C"> - </span>
                        </template>
                    </el-table-column>


                </el-table>
            </div>
        </div>
        <el-dialog :title="carNumber + '  图片审核'"   :visible.sync="examineImg" width="80%" center :close-on-click-modal="false">
            <div style="display: inline-block; height: 90%;">
                <div class="img-box" v-for="(item, index) in dossierImageVerifyDetail" :key="index" @click="changeStatus(item)">
                    <img style="width: 100%;" :src="item.imgUrl" />
                    <p>部位：{{item.positionName}}</p>
                    <p>名称：{{item.imageName}}</p>
                    <p>检测技师：{{item.workerName}}</p>
                    <p>状态：<span v-if="item.result ==0" style="color: #67C23A">{{item.resultLebel}}</span><span v-else style="color: #E6A23C">{{item.resultLebel}}</span></p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="examineImg = false">取 消</el-button>
                <el-button type="primary" @click="submitResult">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="修改状态" :visible.sync="statusShow" width="40%" center :close-on-click-modal="false">
            <div style="text-align: center">
                <el-radio-group v-model="status">
                    <el-radio v-for="(item, index) in reasonList" :key="index" :label="item.key">{{item.tag}}</el-radio>
                </el-radio-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="statusShow = false">取 消</el-button>
                <el-button type="primary" @click="sureChangeStatus">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  export default {
    data() {
      return {

        queryStartDay:'',
        queryEndDay:'',

        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },
        winHeight: "200",
        imageVerifyList:[],
        examineImg: false,
        dossierImageVerifyDetail:[], // 图片列表
        reasonList:[], //原因列表
        statusShow: false,
        status:'', //状态
        configId:'',

        imgItem:'',//暂存
        statusResultList:[], //存放修改后的状态
        carNumber:'',

      };
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));

      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let day = obj.getDate();
      if (day < 10) day = "0" + day;


      // 明天
      let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
      let afterMonth = after.getMonth() + 1;
      if (afterMonth < 10) afterMonth = "0" + afterMonth;
      let afterDay = after.getDate()
      if (afterDay < 10) afterDay = "0" + afterDay;

      let beginDate = obj.getFullYear() + "-" + month + "-01"; //本月第一天
      let endDate = after.getFullYear() + "-" + afterMonth + "-" + afterDay; //明天

      this.queryStartDay = beginDate
      this.queryEndDay = endDate;
    },
    methods: {
      // 表头样式
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },

      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },


      // 获取列表
      getImageVerifyList(){
        if (this.queryStartDay === "" || this.queryStartDay === null || this.queryEndDay === "" || this.queryEndDay === null) {
          net.message(this, "请选择查询时间和站点", "warning");
          return;
        }
        const params = {
          queryStartDay: this.queryStartDay,
          queryEndDay: this.queryEndDay
        }
        net.request("admin/manage/dossier/doImageVerify/getImageVerifyList", "post", params).then(res => {
          if (res.retcode == 1) {
            let data = res.data
            data.forEach(item => {
              if(item.verifyTime){
                item.verifyTimeLabel = net.dateFormat(item.verifyTime)
              }
            })
            this.imageVerifyList = data;
            this.winHeight = net.setWindowHeight0('search')
            // this.winHeight = net.setWindowHeight('search')
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
      },
      // 审核按钮
      examine(row){
        this.dossierImageVerifyDetail = []
        net.request("admin/manage/dossier/doImageVerify/getDossierImageVerifyDetail", "post", {dossierId: row.dossierId}).then(res => {
          if (res.retcode == 1) {
            let data = res.data.imageList
            let reasonList = res.data.reasonList
            data.forEach(item => {
              // item.imgUrl = 'http://116.62.196.51:8443/app/power/image/getImage?time='+Date.now()+'&code=imgshow&imageId='+item.imageId
              item.imgUrl = net.baseUrl+'admin/manage/others/image/getImg/'+item.imageId
              for(let i=0; i<reasonList.length; i++){
                if(item.result == reasonList[i].key){
                  item.resultLebel = reasonList[i].tag
                }
              }
            })
            this.carNumber = row.carNumber
            this.dossierImageVerifyDetail = data;
            this.reasonList = reasonList
            this.examineImg = true
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
      },
      // 点击图片 修改状态
      changeStatus(item){
        this.statusShow = true
        this.status = item.result
        this.configId = item.configId
        this.imgItem = item
      },
      // 修改状态
      sureChangeStatus(){
        let statusResultList = this.statusResultList
        let oldResult = this.imgItem.result
        let newResult = this.status
        let dossierImageVerifyDetail = this.dossierImageVerifyDetail
        let reasonList = this.reasonList
        if(oldResult*1 !== newResult*1){ //状态改变
          statusResultList.push({ //暂存起来
            configId: this.configId,
            result: newResult
          })
          // 回显状态
          dossierImageVerifyDetail.forEach(item => {
            if(item.configId == this.configId){
              item.result = newResult
              for(let i=0; i<reasonList.length; i++){
                if(item.result == reasonList[i].key){
                  item.resultLebel = reasonList[i].tag
                }
              }
            }
          })
        }
        this.statusResultList = statusResultList
        this.dossierImageVerifyDetail = dossierImageVerifyDetail

        this.statusShow = false

      },
      // 提交
      submitResult(){
        let statusResultList = this.statusResultList
        let dossierId = this.dossierImageVerifyDetail[0].dossierId
        net.request('admin/manage/dossier/doImageVerify/saveDossierImageVerifyResult', 'post', {dossierId:dossierId}, statusResultList).then(res => {
          if (res.retcode == 1){
            net.message(this, res.retmsg, "success");
            this.examineImg = false
            this.getImageVerifyList()
          } else {
            net.message(this, res.retmsg, "warning");
          }
        })
      },

      // 导出数据
      exportTable() {
        let elTableId = ''
        if(this.activeName === 'third'){
          elTableId = '#countSoldDetailTable'
        }
        var wb = XLSX.utils.table_to_book(document.querySelector(elTableId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "销售数据整理.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
      // 设置滚动高度
      setWindowHeight() {
        this.winHeight = net.setWindowHeight('search')
      },
      // 排序 降序
      compareDes: function(property) {
        return function (a, b) {
          const value1 = a[property];
          const value2 = b[property];
          return value2 - value1;
        }
      },
    }
  };
</script>

<style lang='less' scoped>
    #userList {
        padding-left: 24px;
        .searchContent {
            height: 48px;
            background: #fff;
            margin: 24px 0 0px 0;
            padding-left: 12px;
            padding-top: 12px;
            .p_select {
                display: flex;
                font-size: 12px;
                float: left;
                margin-right: 12px;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }

            .search_btn {
                width: 76px;
                height: 36px;
                line-height: 36px;
                background: #2B54FC;
                box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
                border-radius: 4px;
                color: #FFFFFF;
                font-size: 14px;
            }
        }
        .table {
            background: #fff;
            padding: 0 12px 12px 12px;
        }


        .update_btn {
            width: 54px;
            height: 28px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            font-size: 12px;
            color: #364556;
            text-align: center;
        }


        /deep/ .table_header {
            background: #F3F7FB !important;
            color: #364556;
        }
        .img-box {
            width: 32%;
            margin-left: 1%;
            display: inline-block;
            background: #eee;
            margin-bottom: 10px;
            padding-bottom: 10px;
            border-radius: 10px;
            overflow: hidden;
            p {
                line-height: 25px;
                text-align: center;
            }
        }
        .el-dialog__body {
            text-align: center !important;
            .el-radio-group {
                display: inline-grid;
                text-align: left;
                .el-radio {
                    line-height: 25px;
                }
            }
        }
    }


</style>

